import {
  // eslint-disable-next-line comma-dangle
  useCallback,
  useMemo,
  useEffect,
  useContext,
} from 'react';
import { useTranslation } from 'react-i18next';
import Header from 'common/components/Header/Header';
import useItem from 'common/hooks/useItem';
import useRouter from 'common/hooks/use-router';
import useList from 'common/hooks/useList';
import FilteredList from 'common/components/Table/FilteredList';

import AlertsContext from 'common/providers/alerts';
import { MdOutlineCategory } from 'react-icons/md';
import { Reason } from 'types/Reason';
import ReasonItem from './ReasonItem';

function Reasons() {
  const { t } = useTranslation();
  const { setAlert } = useContext(AlertsContext);

  const {
    fetchItems,
    items,
    isFetching,
    filters,
    setFilter,
    pageCount,
    setPageIndex,
    pageIndex,
    removeListItem,
    itemsCount,
    itemsPerPage,
    error: errorList1,
  } = useList<Reason>('reasons', {
    defaultSorts: ['updatedAt:DESC', 'createdAt:DESC'],
    defaultSort: 'order:ASC',
    overrideItemsPerPage: 10,
  });

  useEffect(() => {
    if (errorList1) {
      setAlert(errorList1, 'danger');
    }
  }, [errorList1, setAlert]);

  const { removeItem } = useItem<Reason>('reasons', '');

  const { navigate } = useRouter();

  const handleNavigate = (id: any) => {
    navigate(`/reasons/edit/${id}`);
  };

  const handleDelete = useCallback(
    async (id: any) => {
      try {
        removeListItem(id);
        await removeItem(id);
        fetchItems();
      } catch (e) {
        setAlert(e, 'danger');
        return e;
      }
      return true;
    },
    [removeListItem, fetchItems, removeItem, setAlert]
  );

  const columns = useMemo(
    () => [
      {
        Header: t('forms.name'),
        filterName: 'name$containsi',
        filterLabel: t('filters.search'),
        columnClasses: 'md:flex-1 max-w-[400px]',
      },
    ],
    [t]
  );

  const setOverallFilter = useCallback(
    (key: string, value: string | number | boolean) => {
      setFilter(key, value);
    },
    [setFilter]
  );

  return (
    <div className="mx-auto max-w-full py-6 px-6 text-slate-500">
      <Header
        title={t('titlePages.reasons')}
        subTitle={t('titleLegends.reasons')}
        btnTitle={t('newItem.reason')}
        btnSubtitle={t('newItem.reasonLegend')}
        Icon={MdOutlineCategory}
        addLink="/reasons/add"
        isBeforeFilters
      />

      <FilteredList
        data={items ?? []}
        columns={columns} // used as filter items
        isFetching={isFetching}
        pageCount={pageCount}
        filters={filters}
        setFilter={setOverallFilter}
        setPageIndex={setPageIndex}
        pageIndex={pageIndex}
        RenderItem={ReasonItem}
        onDelete={handleDelete}
        onNavigate={handleNavigate}
        itemsCount={itemsCount}
        itemsPerPage={itemsPerPage}
      />
    </div>
  );
}

export default Reasons;
